<template>
    <div class="w-100 h-100 position-fixed d-flex align-content-center" style="background-color: #19162c;"
         @dblclick="$emit('cancel')">
        <b-img :src="require('../../../../assets/images/project_info_background.svg')" alt="bg" fluid-grow
               class="m-auto w-100"/>
        <div class="position-absolute w-100 h-100 d-flex align-content-center" style="z-index: 100">
            <b-container class="m-auto">
                <b-row class="mb-5">
                    <b-col cols="5"><h1>工位/Work Station</h1></b-col>
                    <b-col cols="5"><h1>{{ workStation }}</h1></b-col>
                </b-row>

                <b-row v-for="(item,index) of listInfo" :key="index" class="mt-3">
                    <b-col cols="5"><h2>{{ item.name }}</h2></b-col>
                    <b-col cols="5"><h2>{{ item.value }}</h2></b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import {getOrDefault} from "@/components/LayoutMaps/maps/MapFunction";
import moment from "moment";

export default {
    name: "PrdProjectInfoPage",
    props: {
        projectCode: String,
        workStation: String
    },
    computed: {
        listInfo() {
            return [
                {name: '项目号/Project Code', value: this.projectInfo.projectCode},
                {name: '项目名称/Project Name', value: this.projectInfo.projectName},
                {name: '项目机型/Project Machine Type', value: this.projectInfo.machine1},
                {name: '客户名称/Client', value: getOrDefault('customerName', this.projectInfo, '')},
                {
                    name: '交货期/Delivery Date',
                    value: moment(this.projectInfo.endTime).format(this.$t("em.date.format.viewMode"))
                },
                {name: '交货条款/Delivery Incoterms', value: this.projectInfo.deliveryMethod},
            ];
        },
    },
    data() {
        return {
            projectInfo: {}
        }
    },
    mounted() {
        this.getProjectInfo();
    },
    methods: {
        getProjectInfo() {
            if (this.projectCode) {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectPlanPrp/getOneByCode?projectCode=" + this.projectCode,
                }).then(response => {
                    if (response) {
                        this.projectInfo = response;
                    }
                })
            }
        },
    },
}
</script>

<style scoped>
h1 {
    color: white;
}

h2 {
    color: white;
}
</style>